import React from 'react';
import { Box, LinearProgress } from '@mui/material';

export default function ProgressIndicator() {
  return (
    <Box sx={{ width: '100%' }}>
      <LinearProgress color="info" />
    </Box>
  );
}
